import { useState } from 'react'
import FxExpensesTab from './ExpensesTab'
import FxCashPositionTab from './CashPositionTab'

type TabKey = 'expenses' | 'cash_position'

const tabs: { key: TabKey; label: string }[] = [
  { key: 'expenses', label: 'Gastos' },
  { key: 'cash_position', label: 'Posición de Caja' },
]

/** No "Cobranza" tab here unlike the coffee business's FinanzasPage -- every
 * FX Admin sale is cash, paid in full, confirmed with the business owner, so
 * there's no accounts-receivable concept to show. */
export default function FxFinanzasPage() {
  const [activeTab, setActiveTab] = useState<TabKey>('expenses')

  return (
    <div>
      <h1 className="text-2xl font-bold text-espresso-800 mb-6">Finanzas — FX Admin</h1>

      <div role="tablist" aria-label="Secciones de finanzas" className="flex flex-wrap gap-1 border-b border-espresso-200 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium rounded-t-md border-b-2 -mb-px focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500 ${
              activeTab === tab.key
                ? 'border-terracotta-600 text-terracotta-700 bg-terracotta-50'
                : 'border-transparent text-espresso-500 hover:text-espresso-800 hover:bg-cream-100'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div role="tabpanel">
        {activeTab === 'expenses' && <FxExpensesTab />}
        {activeTab === 'cash_position' && <FxCashPositionTab />}
      </div>
    </div>
  )
}
